import { jsx as _jsx } from "react/jsx-runtime";
import { MULTISELECT_FILTER } from '@as-react/common-types';
import { Column, ImageCheckbox, Row } from '@as/cotopaxi';
import { capitalize } from '@as-react/common-utils';
const FILTER_ITEM_COLOR_DIMENSION = 32;
export const FilterItemContentColorFilter = ({ filter, onFilterItemChange, desktop, isCollapsedByDefault, }) => {
    const toggleFilterValue = (e) => {
        const filteredItem = filter.values.find((value) => value.filterKey === e.target.value);
        if (filteredItem) {
            onFilterItemChange({
                filterOn: filter.filterOn,
                filterOnName: filter.name,
                filteredItems: [
                    {
                        filterKeyName: filteredItem.name,
                        filterKey: filteredItem.filterKey,
                        filterOn: filter.filterOn,
                        filterOnName: filter.name,
                        filterType: MULTISELECT_FILTER,
                    },
                ],
                filterType: MULTISELECT_FILTER,
                filterDisplayHint: filter.displayHint,
                filterContentType: filter.filterContentType,
            });
        }
    };
    return (_jsx(Row, { clear: true, parent: true, children: filter.values.map((value, index) => (_jsx(Column, { grid: 6, gutter: false, gutterBottom: true, gutterTop: index > 1, children: _jsx(ImageCheckbox, { id: desktop ? `color_${filter.name}_${value.filterKey}-desktop` : `color_${filter.name}_${value.filterKey}`, name: `color_${filter.name}_${value.filterKey}`, imageUrl: `/content/dam/general/lister/color_filters/${value.filterKey}.svg`, value: value.filterKey, label: capitalize(value.name), itemCount: value.itemCount, checked: value.active, onChange: toggleFilterValue, imageLazyLoad: isCollapsedByDefault === false, imageHeight: FILTER_ITEM_COLOR_DIMENSION, imageWidth: FILTER_ITEM_COLOR_DIMENSION }) }, `color_${filter.name}_${value.filterKey}`))) }));
};
